import { useEffect, useState } from 'react';
import { useAuth } from '@/hooks/useAuth';

/**
 * Whether the signed-in user holds the `admin` custom claim, or null while it
 * is still being checked. The token is
 * force-refreshed once so a newly granted claim applies without signing out.
 * This only controls what the UI shows; every admin callable checks the claim
 * server-side.
 */
export function useIsAdmin(): boolean | null {
  const { user, loading } = useAuth();
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null);

  useEffect(() => {
    if (loading) return;
    if (!user) {
      setIsAdmin(false);
      return;
    }
    let cancelled = false;
    user.getIdTokenResult(true)
      .then((result) => { if (!cancelled) setIsAdmin(result.claims.admin === true); })
      .catch(() => { if (!cancelled) setIsAdmin(false); });
    return () => { cancelled = true; };
  }, [user, loading]);

  return isAdmin;
}
